define(function () {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const builder = require('civicsUtils/buildUrlParameters');
	const Utils = require('civicsUtils/general_utilities');

	return IpsModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/core/views/assignments',
		url: function () {
			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters)
			}
			//temporary code while we switch RS parameter names. this way we won't break QA builds.

			if (this.storedProcedureMode === true) {
				if (parameters.indexOf('?') >= 0) {
						this.urlRoot ='/delegate/civics-api/api/portal/myassignments',
						parameters += '&compatiblemode=true';
				}
			}
			if (this.view) {
				parameters += (parameters.indexOf('?') >= 0 ? '&' : '?') + 'view=' + this.view;
			}
			var ret = this.urlRoot + parameters;
			if (ret.indexOf('includecount') >= 0) {
				if (ret.indexOf('?') < 0) {
					ret += '?';
				} else {
					ret += '&';
				}
				ret += 'gettotalcount=true';
			}
			return ret;
		},
		modelId: function (attrs) {
			return attrs.assignmentType + '_' + attrs.id;
		},
		parse: function (response) {
			var data = response.data;
			
			//if the collection is supposed to manage the has more records flag,
			//we need to check for the extra record, and remove the last one.
			if (this.manageHasMoreRecords === true && this.hasMoreRecordsCheckSize == response.data.length) {
				data.pop();
				this.hasMoreRecords = true;
			} else {
				this.hasMoreRecords = false;
			}

			
			for (i = 0; i < data.length; i++) {
				switch (data[i].assignmentType) {
					case 'BuildingInspection':
						data[i]._cdrType = 'building';
						data[i]._dataType = 'building.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'LicenseInspection':
						data[i]._cdrType = 'businessLicense';
						data[i]._dataType = 'businessLicense.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'CaseInspection':
						data[i]._cdrType = 'codeEnforcement';
						data[i]._dataType = 'codeEnforcement.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'PlanningInspection':
						data[i]._cdrType = 'planning';
						data[i]._dataType = 'planning.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'ProjectInspection':
						data[i]._cdrType = 'project';
						data[i]._dataType = 'project.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'TradeInspection':
						data[i]._cdrType = 'tradeLicense';
						data[i]._dataType = 'tradeLicense.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'UseInspection':
						data[i]._cdrType = 'use';
						data[i]._dataType = 'use.Inspection';
						data[i]._assignmentType = 'inspection';
						break;
					case 'BuildingReview':
						data[i]._cdrType = 'building';
						data[i]._dataType = 'building.Review';
						data[i]._assignmentType = 'review';
						break;
					case 'LicenseReview':
						data[i]._cdrType = 'businessLicense';
						data[i]._dataType = 'businessLicense.Review';
						data[i]._assignmentType = 'review';
						break;
					case 'CaseReview':
						data[i]._cdrType = 'codeEnforcement';
						data[i]._dataType = 'codeEnforcement.Review';
						data[i]._assignmentType = 'review';
						break;
					case 'PlanningReview':
						data[i]._cdrType = 'planning';
						data[i]._dataType = 'planning.Review';
						data[i]._assignmentType = 'review';
						break;
					case 'ProjectReview':
						data[i]._cdrType = 'project';
						data[i]._dataType = 'project.Review';
						data[i]._assignmentType = 'review';
						break;
					case 'TradeReview':
						data[i]._cdrType = 'tradeLicense';
						data[i]._dataType = 'tradeLicense.Review';
						data[i]._assignmentType = 'review';
						break;
					case 'UseReview':
						data[i]._cdrType = 'use';
						data[i]._dataType = 'use.Review';
						data[i]._assignmentType = 'review';
						break;

					default:
						console.log('undefined/invalid product family from the assignment response');
				}
				data[i].application = data[i].instrument;
				data[i].result = data[i].status;
				data[i].resultDescription = data[i].statusDescription;
				data[i].inspectionType = { description: data[i].description, portalDescription: data[i].portalDescription, };
				data[i].reviewType = { description: data[i].description, portalDescription: data[i].portalDescription, };
				//if (data)
				data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description);
				if (data[i].computedDescription.trim().length <= 0) {
					data[i].computedDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
				//Set the Series Number
				if (data[i]._assignmentType == 'inspection') {
					data[i].inspectionTypeNumber = data[i].subTypeNumber;
				}
				else {
					data[i].reviewTypeNumber = data[i].subTypeNumber;
				}

				if (!Utils.dateExists(data[i].resultDateTime)) {
					if (Utils.dateExists(data[i].startDateTime) ||
						Utils.dateExists(data[i].completedDateTime) ||
						data[i].hours > 0) {
						// recording is partially complete
						data[i].isRecordingStarted = true;
					}
				} else {
					data[i].isRecordingStarted = false;
				}

				if(data[i].instrument) {
					var spacialData = data[i].instrument.Spatial;

					//locationline 1 - address, parcel, property & asset
					//locationline 4 & 5 - x/y coordinate
					if (data[i].instrument.locationLine1 == '') {
						data[i].instrument.locationLine4 = spacialData ? 'x: ' + spacialData.xCoordinate : '';
						data[i].instrument.locationLine5 = spacialData ? 'y: ' + spacialData.yCoordinate : '';
					}

				}

			}
			return data;
		}
	});
});
